import React, { useState, useEffect } from 'react';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Проверяем, принял ли пользователь уже cookie-соглашение
    const hasConsent = localStorage.getItem('cookieConsent');
    if (!hasConsent) {
      setIsVisible(true);
    }
  }, []);
  
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };
  
  if (!isVisible) return null;
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 py-3 bg-[#BCDE02] text-black font-medium flex items-center justify-between">
      <p className="text-sm md:text-base pr-4">
        We use cookies on our website to provide you with the most relevant experience by remembering your preferences and repeat visits.
        By clicking "accept," you agree to the use of ALL cookies.RetryClaude can make mistakes. Please double-check responses.
      </p>
      <button 
        onClick={handleAccept}
        className="bg-black text-white px-4 py-2 rounded whitespace-nowrap hover:bg-gray-800 transition-colors"
      >
        Accept
      </button>
    </div>
  );
};

export default CookieConsent;